import { Box, SxProps, Theme } from '@mui/material'
import { FC } from 'react'
import ReactQuill from 'react-quill'
// @ts-ignore
import 'react-quill/dist/quill.snow.css'

interface RichTextViewerProps {
  html: string
  maxHeight?: number | string
  height?: number | string
  sx?: SxProps<Theme>
}

export const RichTextViewer: FC<RichTextViewerProps> = ({ html, maxHeight = 400, height, sx }) => (
  <Box
    sx={[
      {
        '& .ql-editor': { height: height ?? 'auto', maxHeight: height ?? maxHeight, overflowY: 'auto', fontWeight: 400 },
        '& .ql-editor strong': { fontWeight: 700 },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    <ReactQuill readOnly value={html} modules={{ toolbar: false }} />
  </Box>
)
